import { useSearchQuery } from '../../../../__generated__/chirp/com/hubspot/learning/center/search/rpc/SearchChirpService.hooks';

// current base: variation 21
export const SearchScoringBaseConfiguration = {
  recencyOffset: 'PT72H0M',
  recencyScale: 'PT72H0M',
  recencyDecay: 0.7,
  nameBoost: 50,
  descriptionBoost: 25,
  professorsBoost: 10,
  introContentNameBoost: 15,
  introContentDescriptionBoost: 7.5,
  introContentBoost: 5,
  subContentNamesBoost: 12,
  subContentDescriptionsBoost: 6,
  subContentsBoost: 1.5,
  categoriesBoost: 3,
  hubspotSoftwareBoost: 2,
  levelsBoost: 1,
  weightProgressInProgress: 0.1,
  weightProgressCompleted: 1,
  includeRecencyDecay: true,
  includeUserProgress: true
};
export const useSearch = ({
  variables,
  skip,
  scoringConfig: customScoringConfig
}) => {
  const {
    data: searchResults,
    loading: searchResultsLoading,
    error: searchResultsError
  } = useSearchQuery({
    variables: Object.assign({}, variables, {
      scoringConfig: Object.assign({}, SearchScoringBaseConfiguration, customScoringConfig)
    }),
    skip
  });
  return {
    searchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults.results,
    searchResultsLoading,
    searchResultsError,
    totalCount: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.total) || 0,
    correlationId: searchResults === null || searchResults === void 0 ? void 0 : searchResults.correlationId
  };
};